import React, { useEffect, useState, useCallback } from "react";
import { Trans } from "@lingui/macro";
import {
  connectCurrentRefinements,
  connectStateResults,
} from "react-instantsearch-dom";
import CourseCard from "../courseCard";
import CourseCardMock from "../courseCardMock";
import CourseCardMobile from "../courseCardMobile";
import CourseCardMobileMock from "../courseCardMobileMock";
import { isCourseInCart } from "~/utils/app-helpers";
import { useBreakpoint } from "../../../breakpoint.js";
import PricesContext from "~/providers/pricesProvider";
import usePrices from "~/hooks/usePrices";
import Link from "~/components/link";

const Hits = ({ hits, ...props }) => {
  const breakpoints = useBreakpoint();
  const [coursesIDs, setCoursesIds] = useState("");
  const courses = JSON.stringify(hits);

  const { data } = usePrices(coursesIDs);
  const [results, setResultStatus] = useState(null);

  useEffect(() => {
    const hits = JSON.parse(courses);

    if (hits.length > 0) {
      const myIds = hits.map((hit) => hit.objectID);
      const joinedIds = myIds.join(",");

      setCoursesIds(joinedIds);
      setResultStatus(true);
    } else {
      setResultStatus(true);
    }

    return () => {
      return false;
    };
  }, [courses]);

  return (
    <div className="flex flex-wrap items-center justify-center">
      <PricesContext.Provider value={data}>
        {hits.map((hit) => {
          const exists = isCourseInCart(hit, props.products);

          let funcCart = () => (e) => {
            e.preventDefault();
            e.stopPropagation();

            return undefined;
          };

          if (!exists) {
            funcCart = (product) => (e) => {
              e.preventDefault();
              e.stopPropagation();
              props.addToCartAction(product);
            };
          }

          hit.ID = parseInt(hit.objectID);

          return (
            <div
              className="pb-2 w-full sm:w-auto"
              key={`id_search_${hit.objectID}`}
            >
              <div className="relative ml-1 w-full sm:w-auto xl:ml-6">
                {!breakpoints.sm ? (
                  <CourseCard
                    {...hit}
                    actionFunc={funcCart}
                    // actionToMake={actionToMake}
                    lazy={false}
                    locale={props.locale}
                    exists={exists}
                  />
                ) : (
                  <CourseCardMobile
                    {...hit}
                    actionFunc={funcCart}
                    // actionToMake={actionToMake}
                    lazy={false}
                    locale={props.locale}
                    exists={exists}
                  />
                )}
              </div>
            </div>
          );
        })}
      </PricesContext.Provider>
    </div>
  );
};

const Content = connectStateResults(
  ({ searchState, searchResults, isSearchStalled, ...props }) => {
    if (isSearchStalled) {
      const breakpoints = useBreakpoint();

      return (
        <div className="flex flex-wrap items-center justify-center">
          {!breakpoints.sm ? (
            <>
              <div className="pb-2 w-full sm:w-auto">
                <div className="relative ml-1 w-full sm:w-auto xl:ml-6">
                  <CourseCardMock />
                </div>
              </div>
              <div className="pb-2 w-full sm:w-auto">
                <div className="relative ml-1 w-full sm:w-auto xl:ml-6">
                  <CourseCardMock />
                </div>
              </div>
              <div className="pb-2 w-full sm:w-auto">
                <div className="relative ml-1 w-full sm:w-auto xl:ml-6">
                  <CourseCardMock />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="pb-2 w-full sm:w-auto">
                <div className="relative ml-1 w-full sm:w-auto xl:ml-6">
                  <CourseCardMobileMock />
                </div>
              </div>
              <div className="pb-2 w-full sm:w-auto">
                <div className="relative ml-1 w-full sm:w-auto xl:ml-6">
                  <CourseCardMobileMock />
                </div>
              </div>
              <div className="pb-2 w-full sm:w-auto">
                <div className="relative ml-1 w-full sm:w-auto xl:ml-6">
                  <CourseCardMobileMock />
                </div>
              </div>
            </>
          )}
        </div>
      );
    }

    if (searchResults && searchResults.nbHits === 0) {
      return (
        <div className="text-2xl text-center p-8">
          <p>
            <Trans>No results has been found</Trans>
          </p>
          <ClearRefinements clearsQuery={true} />
        </div>
      );
    }

    return <Hits hits={searchResults.hits} {...{ ...props }} />;
  }
);

const ClearRefinements = connectCurrentRefinements(({ items, refine }) => (
  <button
    className="btn btn-primary mt-6 py-2 xl:py-3 inline-block w-full md:w-1/3 md:text-2xl"
    onClick={() => refine(items)}
    // clearsQuery={true}
    // disabled={!items.length}
  >
    <Trans>View all courses</Trans>
  </button>
));

export default Content;
